import { render } from "./AccountOrderDetailsShipmentItem.vue?vue&type=template&id=8fa48f80"
import script from "./AccountOrderDetailsShipmentItem.vue?vue&type=script&lang=js"
export * from "./AccountOrderDetailsShipmentItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__